module.exports = __webpack_public_path__ + "static/img/resistor_10k-1.acf3fb9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/resistor_10k-1.svg
// module id = RPQ3
// module chunks = 0